import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Modal from "../../../componentes/modal/modal";
import Button from "../../../componentes/button/button";
import Input from "../../../componentes/input/input";
import InputMoney from "../../../componentes/input/inputMoney";
import { CustomDropdown } from "../../../componentes/dropdown/CustomDropdown";
import SelecionarFornecedorModal from "../FormEtapas/shared/SelecionarFornecedorModal";
import FilialService from "../../../services/resource/filialService";
import CentroCustoService from "../../../services/resource/CentroCustoService";
import TipoPagamentoService from "../../../services/resource/tipoPagamentoService";
import DespesaRecorrenteService from "../../../services/resource/despesaRecorrenteService";
import { formatarCnpjCpf } from "../../../utils/solicitacoes/formatters";

const filialService = new FilialService();
const centroCustoService = new CentroCustoService();
const tipoPagamentoService = new TipoPagamentoService();
const service = new DespesaRecorrenteService();

const TIPO_DESPESA_OPTIONS = [
    { value: "SUPRIMENTOS", label: "Suprimentos" },
    { value: "CONTAS_A_PAGAR", label: "Contas a Pagar" },
];

const ANTECEDENCIA_OPTIONS = [0, 1, 2, 3, 5, 7].map(v => ({ value: v, label: `${v} dia${v === 1 ? "" : "s"} de antecedência` }));

const MESES = [
    { valor: 1, label: "Jan" }, { valor: 2, label: "Fev" }, { valor: 3, label: "Mar" },
    { valor: 4, label: "Abr" }, { valor: 5, label: "Mai" }, { valor: 6, label: "Jun" },
    { valor: 7, label: "Jul" }, { valor: 8, label: "Ago" }, { valor: 9, label: "Set" },
    { valor: 10, label: "Out" }, { valor: 11, label: "Nov" }, { valor: 12, label: "Dez" },
];
const TODOS_OS_MESES = MESES.map(m => m.valor);

const inicial = {
    descricao: "",
    diaLancamento: "",
    diaVencimento: "",
    fornecedorId: null,
    filialId: Number(localStorage.getItem("filialId")) || null,
    centroCustoCodigo: null,
    tipoDespesa: "SUPRIMENTOS",
    valorPrevisto: "",
    tipoPagamento: "",
    origemNotaFiscal: "",
    observacoes: "",
    receberEmail: true,
    diasAntecedencia: 0,
    dataFim: "",
    mesesRecorrencia: TODOS_OS_MESES,
};

/** Cadastro/edição de uma Despesa Recorrente. Em edição, `despesaRecorrente` traz o DTO carregado do backend. */
export default function ModalCadastroDespesaRecorrente({ isOpen, onClose, despesaRecorrente, onSalvo }) {
    const [form, setForm] = useState(inicial);
    const [fornecedorSelecionado, setFornecedorSelecionado] = useState(null);
    const [modalFornecedorAberto, setModalFornecedorAberto] = useState(false);
    const [filiais, setFiliais] = useState([]);
    const [centrosCusto, setCentrosCusto] = useState([]);
    const [tiposPagamento, setTiposPagamento] = useState([]);
    const [salvando, setSalvando] = useState(false);

    const editando = !!despesaRecorrente;

    useEffect(() => {
        if (!isOpen) return;
        filialService.listarAtivas().then(res => setFiliais(res.data)).catch(() => setFiliais([]));
        centroCustoService.listar().then(res => setCentrosCusto(res.data)).catch(() => setCentrosCusto([]));
        tipoPagamentoService.listar().then(res => setTiposPagamento(res.data)).catch(() => setTiposPagamento([]));
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen) return;
        if (despesaRecorrente) {
            setForm({
                descricao: despesaRecorrente.descricao || "",
                diaLancamento: despesaRecorrente.diaLancamento ?? "",
                diaVencimento: despesaRecorrente.diaVencimento ?? "",
                fornecedorId: despesaRecorrente.fornecedorId ?? null,
                filialId: despesaRecorrente.filialId ?? null,
                centroCustoCodigo: despesaRecorrente.centroCustoCodigo ?? null,
                tipoDespesa: despesaRecorrente.tipoDespesa || "SUPRIMENTOS",
                valorPrevisto: despesaRecorrente.valorPrevisto ?? "",
                tipoPagamento: despesaRecorrente.tipoPagamento || "",
                origemNotaFiscal: despesaRecorrente.origemNotaFiscal || "",
                observacoes: despesaRecorrente.observacoes || "",
                receberEmail: despesaRecorrente.receberEmail ?? true,
                diasAntecedencia: despesaRecorrente.diasAntecedencia ?? 0,
                dataFim: despesaRecorrente.dataFim || "",
                mesesRecorrencia: despesaRecorrente.mesesRecorrencia?.length ? despesaRecorrente.mesesRecorrencia : TODOS_OS_MESES,
            });
            setFornecedorSelecionado(despesaRecorrente.fornecedorId
                ? { id: despesaRecorrente.fornecedorId, nome: despesaRecorrente.fornecedorNome }
                : null);
        } else {
            setForm(inicial);
            setFornecedorSelecionado(null);
        }
    }, [isOpen, despesaRecorrente]);

    function set(campo, valor) {
        setForm(prev => ({ ...prev, [campo]: valor }));
    }

    function selecionarFornecedor(fornecedor) {
        setFornecedorSelecionado(fornecedor);
        set("fornecedorId", fornecedor.id);
    }

    function alternarMes(valor) {
        setForm(prev => ({
            ...prev,
            mesesRecorrencia: prev.mesesRecorrencia.includes(valor)
                ? prev.mesesRecorrencia.filter(m => m !== valor)
                : [...prev.mesesRecorrencia, valor],
        }));
    }

    function validar() {
        if (!form.descricao.trim()) {
            toast.error("Informe a descrição da despesa recorrente.");
            return false;
        }
        const dl = Number(form.diaLancamento);
        const dv = Number(form.diaVencimento);
        if (!dl || dl < 1 || dl > 31) {
            toast.error("Informe um dia de lançamento válido (1 a 31).");
            return false;
        }
        if (!dv || dv < 1 || dv > 31) {
            toast.error("Informe um dia de vencimento válido (1 a 31).");
            return false;
        }
        if (!form.mesesRecorrencia.length) {
            toast.error("Selecione pelo menos um mês de recorrência.");
            return false;
        }
        return true;
    }

    function salvar() {
        if (!validar()) return;

        const dados = {
            descricao: form.descricao.trim(),
            diaLancamento: Number(form.diaLancamento),
            diaVencimento: Number(form.diaVencimento),
            fornecedorId: form.fornecedorId,
            filialId: form.filialId,
            centroCustoCodigo: form.centroCustoCodigo,
            tipoDespesa: form.tipoDespesa,
            valorPrevisto: form.valorPrevisto ? Number(form.valorPrevisto) : null,
            tipoPagamento: form.tipoPagamento,
            origemNotaFiscal: form.origemNotaFiscal,
            observacoes: form.observacoes,
            receberEmail: form.receberEmail,
            diasAntecedencia: Number(form.diasAntecedencia) || 0,
            dataFim: form.dataFim || null,
            mesesRecorrencia: form.mesesRecorrencia,
        };

        setSalvando(true);
        const requisicao = editando ? service.atualizar(despesaRecorrente.id, dados) : service.criar(dados);
        requisicao
            .then(res => {
                toast.success(editando ? "Despesa recorrente atualizada." : "Despesa recorrente cadastrada.");
                onSalvo(res.data);
            })
            .catch(() => { })
            .finally(() => setSalvando(false));
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={editando ? "Editar Despesa Recorrente" : "Nova Despesa Recorrente"}
            subtitle="Cadastre uma despesa que se repete todo mês para ser lembrado e acompanhar o lançamento."
            className="w-[90%] sm:w-[640px]"
            footer={
                <div className="flex justify-end gap-2">
                    <Button variant="outline" label="Cancelar" onClick={onClose} />
                    <Button variant="blue" label="Salvar" loading={salvando} onClick={salvar} />
                </div>
            }
        >
            <div className="p-4 flex flex-col gap-4">
                <Input label="Descrição" required value={form.descricao} onChange={e => set("descricao", e.target.value)} placeholder="Ex.: Aluguel do escritório" />

                <div className="grid grid-cols-2 gap-4">
                    <Input
                        type="number"
                        label="Dia do lançamento"
                        required
                        value={form.diaLancamento}
                        onChange={e => set("diaLancamento", e.target.value)}
                        helpText="Dia do mês em que a despesa deve ser lançada (1 a 31)."
                    />
                    <Input
                        type="number"
                        label="Dia do vencimento"
                        required
                        value={form.diaVencimento}
                        onChange={e => set("diaVencimento", e.target.value)}
                        helpText="Dia do mês em que a despesa vence (1 a 31)."
                    />
                </div>

                <div className="flex flex-col gap-1.5">
                    <label className="text-sm font-medium text-foreground/80">Meses de recorrência</label>
                    <div className="flex flex-wrap gap-1.5">
                        {MESES.map(m => {
                            const ativo = form.mesesRecorrencia.includes(m.valor);
                            return (
                                <button
                                    key={m.valor}
                                    type="button"
                                    onClick={() => alternarMes(m.valor)}
                                    className={`px-3 py-1.5 text-sm font-medium rounded-full border transition-colors ${ativo
                                        ? "bg-primary text-primary-foreground border-primary"
                                        : "bg-card text-muted-foreground border-input"}`}
                                >
                                    {m.label}
                                </button>
                            );
                        })}
                    </div>
                    <p className="text-xs text-muted-foreground">
                        Todos marcados = mensal. Marque só os meses desejados pra despesas anuais ou trimestrais (ex.: só Dez, ou Mar/Jun/Set/Dez).
                    </p>
                </div>

                <Input
                    type="date"
                    label="Data fim (opcional)"
                    value={form.dataFim}
                    onChange={e => set("dataFim", e.target.value)}
                    helpText="Deixe em branco para repetir indefinidamente."
                />

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-end">
                    <div className="flex flex-col gap-1.5">
                        <label className="text-sm font-medium text-foreground/80">Fornecedor</label>
                        <Button
                            variant="outline"
                            label={fornecedorSelecionado ? "Trocar Fornecedor" : "Selecionar Fornecedor"}
                            iconLeft="fa fa-search"
                            onClick={() => setModalFornecedorAberto(true)}
                        />
                    </div>
                    <div className="sm:col-span-2">
                        <Input
                            label="Fornecedor selecionado"
                            disabled
                            value={fornecedorSelecionado ? `${fornecedorSelecionado.nome}${fornecedorSelecionado.cnpj || fornecedorSelecionado.cpf ? " — " + formatarCnpjCpf(fornecedorSelecionado.cnpj || fornecedorSelecionado.cpf) : ""}` : ""}
                        />
                    </div>
                </div>

                <SelecionarFornecedorModal
                    isOpen={modalFornecedorAberto}
                    onClose={() => setModalFornecedorAberto(false)}
                    onSelecionar={selecionarFornecedor}
                />

                <Input
                    label="Onde conseguir a nota fiscal"
                    value={form.origemNotaFiscal}
                    onChange={e => set("origemNotaFiscal", e.target.value)}
                    placeholder="Ex.: e-mail financeiro@fornecedor.com, portal do fornecedor, link do site..."
                    helpText="Ajuda a lembrar onde buscar a nota antes de criar o lançamento (e-mail, link, portal etc.)."
                />

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <InputMoney
                        label="Valor previsto"
                        value={form.valorPrevisto}
                        minFractionDigits={2}
                        maxFractionDigits={2}
                        mode="decimal"
                        onFocus={e => e.target.select()}
                        onChange={e => set("valorPrevisto", e.value)}
                    />
                    <CustomDropdown label="Tipo de despesa" value={form.tipoDespesa} onChange={e => set("tipoDespesa", e.value)} options={TIPO_DESPESA_OPTIONS} placeholder="Selecione" />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <CustomDropdown label="Filial" value={form.filialId} onChange={e => set("filialId", e.value)} options={filiais} optionValue="id" optionLabel="nome" placeholder="Selecione" filter showClear />
                    <CustomDropdown
                        label="Tipo de pagamento"
                        value={form.tipoPagamento}
                        onChange={e => set("tipoPagamento", e.value)}
                        options={tiposPagamento}
                        optionValue="nome"
                        optionLabel="nome"
                        placeholder="Selecione"
                        filter
                        showClear
                    />
                    {/* 
                    <CustomDropdown
                        label="Centro de Custo"
                        value={form.centroCustoCodigo}
                        onChange={e => set("centroCustoCodigo", e.value)}
                        options={centrosCusto}
                        optionValue="codigo"
                        optionLabel="descricao"
                        placeholder="Selecione"
                        filter
                        showClear
                    />
                    */}
                </div>

                <Input label="Observações" value={form.observacoes} onChange={e => set("observacoes", e.target.value)} />

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-end">
                    <div className="flex items-center gap-2 h-9">
                        <input
                            id="receberEmail"
                            type="checkbox"
                            checked={form.receberEmail}
                            onChange={e => set("receberEmail", e.target.checked)}
                            className="w-4 h-4 accent-primary"
                        />
                        <label htmlFor="receberEmail" className="text-sm font-medium text-foreground/80">Receber lembrete por e-mail</label>
                    </div>
                    <CustomDropdown
                        label="Lembrar com antecedência"
                        value={form.diasAntecedencia}
                        onChange={e => set("diasAntecedencia", e.value)}
                        options={ANTECEDENCIA_OPTIONS}
                        disabled={!form.receberEmail}
                    />
                </div>
            </div>
        </Modal>
    );
}
